import request from "@/utils/request";

//收益记录
export function queryShopIncomeList(params) {
  return request({
    url: "/api/system/shopIncome/queryShopIncomeList",
    method: "post",
    data: params
  });
}
//收益消费记录
export function queryShopChargeList(params) {
  return request({
    url: "/api/system/shopCharge/queryShopChargeList",
    method: "post",
    data: params
  });
}
//计算总收益
export function totalIncome(params) {
  return request({
    url: "/api/system/shopIncome/totalIncome",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/mine/earning.js